import { cva } from "class-variance-authority";
import Typography, { TextProps } from "../typography";
import "tailwindcss";
import type { ButtonHTMLAttributes } from "react";

interface ButtonProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "children"
> {
  label: string;
  width?: "maxWidth" | "parentWidth" | "max_to_fullWidth";
  intent: "primary" | "secondary";
  heights?: "height40" | "defaultHeight" | "height3rem" | "noHeight";
  textWeight?: TextProps["weight"];
  loading?: boolean;
}

const button = cva(
  [
    "rounded-md py-2 px-[1.75rem] w-full  cursor-pointer interactive-transition disabled:opacity-60 disabled:cursor-not-allowed",
  ],
  {
    variants: {
      width: {
        maxWidth: ["max-w-[12.5rem]"],
        parentWidth: [],
        max_to_fullWidth: ["lg:max-w-[12.5rem] w-full"],
      },
      heights: {
        height40: ["h-10 sm:h-12 items-center justify-center flex"],
        defaultHeight: ["h-[2.625rem]"],
        height3rem: ["h-[3rem]"],
        noHeight: [],
      },
      intent: {
        primary: ["bg-primary", "text-white", "hover:bg-mainHover"],
        secondary: ["bg-secondary hover:bg-lightGray"],
      },
    },

    defaultVariants: {
      width: "maxWidth",
      heights: "defaultHeight",
    },
  },
);

const Button = ({
  label,
  intent,
  className,
  heights,
  width,
  textWeight = 500,
  disabled,
  type,
  loading,
  ...rest
}: ButtonProps) => {
  return (
    <button
      {...rest}
      type={type}
      disabled={disabled || loading}
      aria-busy={loading ? true : undefined}
      className={button({ intent, className, width, heights })}
    >
      <span className="inline-flex items-center justify-center gap-2">
        {loading && (
          <span
            className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent"
            aria-hidden="true"
          />
        )}
        <Typography size="unresponsiveBody1" weight={textWeight}>
          {label}
        </Typography>
      </span>
    </button>
  );
};

export { Button as CustomButton };
export default Button;
